import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { alertService } from '../../services/helpers/alert.service';
import { searchService } from "../../services/api/search.service";
import { reportService } from "../../services/api/report.service";
import { utils } from "../../services/helpers/utils";

export const SearchMMPreauthorizations = (props) => {

    const { partener, deladata, ladata, cnp, status_finalizare, status_aprobare, numePacient, companie, emisDe } = props.params;
    const [lista, setLista] = useState(null);

    const params = {
        partner: partener?.id,
        datastart: deladata ? utils.convertDate(deladata) : "",
        dataend: ladata ? utils.convertDate(ladata) : "",
        cnp: cnp,
        statusfinalizare: status_finalizare.id ?? 0,
        statusaprobare: status_aprobare.id ?? 0,
        numepacient: numePacient ?? "",
        companie: companie ?? ""
    }

    const navigate = useNavigate();

    useEffect(() => {

        if (utils.checkEmptyProperties(props.params)) {
            alertService.error("Trebuie sa completezi macar un parametru!");
        }
        else {

            searchService.getMMPreauthorizations(params).then(response => {
                setLista(response ? response : null);
            });
        }
    }, [props.params]);


    const handleView = (page, param, value) => {

        var encode = {
            displayValue: props.params,
            activeComponent: props.activeComponent
        };

        var encodedString = btoa(JSON.stringify(encode));

        navigate(window.location.hash + `?q=${encodedString}`, { replace: true });
        navigate(`/dashboard/${page}?${param}=${value}`);
    }

    const handleExport = () => {
        reportService.RaportCautarePreautorizariMM({
            cnp: params.cnp,
            deLaData: params.datastart,
            laData: params.dataend,
            statusFinalizare: params.statusfinalizare,
            partener: params.partner,
            nume: params.numepacient,
            companie: params.companie
        }).then((response) => {
            if (response) {
                utils.downloadFile(response, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                return;
            }
        });
    }



    return (
        <>
            {lista &&
                <>
                    <p className="paragraf">Preautorizari:</p>
                    <table className="tbl" name="lista" width="100%">
                        <thead>
                            <tr>
                                <th className="first">Nr</th>
                                <th>Pacient</th>
                                <th>CNP</th>
                                <th>Cod pacient</th>
                                <th>Companie</th>
                                <th>Abonament</th>
                                <th>Tip fisa</th>
                                <th>Status</th>
                                <th>Adaugat la</th>
                                <th>Partener</th>
                                <th>ID</th>
                                <th className="tac">Vezi preautorizare MM</th>
                            </tr>
                        </thead>
                        <tbody>
                            {lista.map((row, index) => (
                                <tr key={index}>
                                    <td name="nr_crt" className="center first">{index + 1}</td>
                                    <td name="nume_pacient"> {row.pacient}</td>
                                    <td name="cnp" className="center"> {row.cnp}</td>
                                    <td name="cod_pacient" className="center"> {row.codPacient}</td>
                                    <td name="nume_firma"> {row.companie}</td>
                                    <td name="nume_profil">
                                        {row.abonament}
                                        {row.firmaMaster && <span> (</span>}
                                        {row.firmaMaster}
                                        {row.firmaMaster && <span>)</span>}
                                    </td>
                                    <td name="tip_fisa">{row.tipFisa}</td>
                                    <td name="status" className="center">{row.status}</td>
                                    <td name="adaugat_la" className="center"> {row.adaugatLa}</td>
                                    <td name="partener" className="center"> {row.partener}</td>
                                    <td className="center"> {row.idPreautorizare}</td>
                                    <td>
                                        <a className="icon deschide m0auto"
                                            onClick={() => handleView("preautorizare-mm", "id", row.idPreautorizare)}
                                            title="Vezi preautorizare MM"
                                            name="view">Vizualizare</a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div name="export">
                    <button name="btn-export" className="btn" onClick={handleExport}>Export</button>
                    </div>
                </>
            }
        </>
    );
};

